(function initFooterLinkToggle() {
  document.querySelectorAll('.footer-block--menu .footer-block__heading--wrapper').forEach((footerLinkBtn) => {
    footerLinkBtn.addEventListener('click', (e) => {
      const footerLink = e.target.closest('.footer-block.grid__item.footer-block--menu');
      if (footerLink.classList.contains('open')) {
        footerLink.classList.remove('open');
      } else {
        footerLink.classList.add('open');
      }
    });
  });
})();
